import { render } from "./PackageDown.vue?vue&type=template&id=2b7d9e20"
import script from "./PackageDown.vue?vue&type=script&lang=js"
export * from "./PackageDown.vue?vue&type=script&lang=js"

import exportComponent from "../vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__